import { useDispatch, useSelector } from 'react-redux'
import { TState } from 'redux/config/root-types'
import { Actions_Modals } from 'redux/modules/modals/Actions'
import { useTranslation } from 'react-i18next'
import { I18nModal } from 'utils/i18n/i18nModal'
import { useForm } from 'react-hook-form'
import { Form } from 'utils/helpers/form'
import { TParentOrganization } from 'redux/modules/parentOrganizations/TReducer'
import { Actions_ParentOrganizations } from 'redux/modules/parentOrganizations/Actions'

type TModalProps = {
  parentOrganization: TParentOrganization
}

interface IForm {
  name: string
  discount: string
}

const formValidation = {
  name: Form.required,
  discount: Form.max(100),
}

export const useParentOrganizationUpdate = () => {
  const { t } = useTranslation(I18nModal.parentOrganizationUpdate)
  const dispatch = useDispatch()

  const modalProps = useSelector(({ modals }: TState) => modals.data as TModalProps)
  const isLoading = useSelector(({ parentOrganizations }: TState) => parentOrganizations.isLoading)

  const { handleSubmit, register, errors, control } = useForm<IForm>({
    defaultValues: {
      name: modalProps.parentOrganization?.name || '',
      discount: modalProps.parentOrganization?.discount?.toString() || '',
    },
  })

  const onSubmit = (formData: IForm) => {
    const id = modalProps.parentOrganization?.id
    const data = {
      ...formData,
      discount: Number(formData.discount),
    }
    dispatch(Actions_ParentOrganizations.saga.updateParentOrganization({ id, data }))
  }

  const closeModal = () => {
    dispatch(Actions_Modals.store.hideModal())
  }

  return {
    t,
    closeModal,
    isLoading,
    form: {
      formValidation,
      errors,
      register,
      control,
      handleSubmit: handleSubmit(onSubmit),
    },
  }
}
